import {
  faBicycle,
  faBus,
  faCar,
  faHome,
} from '@fortawesome/pro-solid-svg-icons';

const categoryLabels = {
  fiets: 'Fiets',
  'public-transport': 'Bus, trein, tram, metro',
  'auto-moto': 'Auto, moto',
  'dicht-bij-huis': 'Dicht bij huis',
};

const categoryIcons = {
  'auto-moto': faCar,
  'public-transport': faBus,
  fiets: faBicycle,
  'dicht-bij-huis': faHome,
};

export { categoryLabels, categoryIcons };
